import React, { createContext, useContext, useState } from "react";
import { config, encrypt, instance } from "./config";

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  /**
   * Objeto que contiene los datos del usuario con la sesión activa.
   */
  const [user, setUser] = useState();

  /**
  * Método para guardar las credenciales del usuario en el localStorage la estructura del userInfo es la siguiente 
  useinfo = {
    apellido:
    area:
    correo:
    fotografia:
    id:
    nombre:
    funciones:
  }
  * @param {*} userInfo 
  */
  const login = (userInfo) => {
    // Lógica para iniciar sesión
    localStorage.setItem(config.user_id, userInfo.id);
    localStorage.setItem(config.user_image, userInfo.fotografia);
    localStorage.setItem(config.user_correo, userInfo.correo);
    localStorage.setItem(config.user_nombre, userInfo.nombre);
    localStorage.setItem(config.user_apellido, userInfo.apellido);
    localStorage.setItem(config.funciones, encrypt(userInfo.funciones));
    userInfo["funciones"] = JSON.parse("[" + userInfo.funciones + "]");
    setUser(userInfo);
  };

  /**
   * Método para poder remover las credenciales del usuario del localStorage
   */
  const logout = async () => {
    try {
      await instance.post('/auth/logout');
    } catch (e) {
      // ignorar error de logout
    }
    setUser(null);
    localStorage.removeItem(config.user_id);
    localStorage.removeItem(config.user_image);
    localStorage.removeItem(config.user_correo);
    localStorage.removeItem(config.user_nombre);
    localStorage.removeItem(config.user_apellido);
    localStorage.removeItem(config.funciones);
    localStorage.removeItem('selectedIndex');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
